function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _invoke from 'lodash/invoke';
import cx from 'classnames';
import { getValidElementProps } from '../utils/htmlValidProps';
import Icon from '../Icon';

require('xps-style/core/button.css');

var propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,

  /** size of button */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /** indicates button kind: primary, secondary, tertiary, borderless */
  kind: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'borderless']),

  /** indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `iconName` */
  icon: PropTypes.oneOf(['right', 'left', 'none', 'only']),

  /** icon name from Material Icons library */
  iconName: PropTypes.string,

  /** button type can be button, reset or submit */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  tabIndex: PropTypes.number,
  includeRef: PropTypes.bool,
  noPadding: PropTypes.bool
};
var defaultProps = {
  type: 'button',
  kind: 'primary',
  size: 'small',
  icon: 'none',
  includeRef: false,
  tabIndex: 0
};

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "button", _this.props.includeRef ? React.createRef() : false);

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      _invoke(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _cx2;

      var _this$props = this.props,
          type = _this$props.type,
          size = _this$props.size,
          kind = _this$props.kind,
          icon = _this$props.icon,
          iconName = _this$props.iconName,
          className = _this$props.className,
          children = _this$props.children,
          disabled = _this$props.disabled,
          tabIndex = _this$props.tabIndex,
          includeRef = _this$props.includeRef,
          noPadding = _this$props.noPadding;
      var btnProps = getValidElementProps('button', this.props);
      var padding = '';

      if (icon === 'left') {
        padding = 'paddingright-md';
      } else if (icon === 'right') {
        padding = 'paddingleft-md';
      } // used in conditional below to set aria-label when button contains an icon with no text


      var iconOnly = icon === 'only';
      var iconClass = cx(_defineProperty({}, padding, true));
      var ntClass = cx((_cx2 = {}, _defineProperty(_cx2, "btn--".concat(size), true), _defineProperty(_cx2, "btn-skin--".concat(kind), true), _defineProperty(_cx2, "btn__icon-".concat(icon), true), _defineProperty(_cx2, "iconNameActive", true), _defineProperty(_cx2, 'btn--compact', noPadding && kind === 'borderless'), _cx2), className);
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/button-has-type
        React.createElement("button", _extends({
          type: type,
          className: ntClass,
          onClick: this.handleClick,
          disabled: disabled
        }, iconOnly && {
          'aria-label': iconName
        }, includeRef && {
          ref: this.button
        }, btnProps, {
          tabIndex: disabled ? -1 : tabIndex
        }), icon === 'left' ? /*#__PURE__*/React.createElement(Icon, {
          className: iconClass,
          name: iconName
        }) : null, icon === 'only' ? /*#__PURE__*/React.createElement(Icon, {
          className: iconClass,
          name: iconName,
          ariaHidden: false
        }) : null, icon === 'only' ? null : children, icon === 'right' ? /*#__PURE__*/React.createElement(Icon, {
          className: iconClass,
          name: iconName
        }) : null)
      );
    }
  }]);

  return Button;
}(Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
Button.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Button",
  "props": {
    "type": {
      "defaultValue": {
        "value": "'button'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'button'",
          "computed": false
        }, {
          "value": "'reset'",
          "computed": false
        }, {
          "value": "'submit'",
          "computed": false
        }]
      },
      "required": false,
      "description": "button type can be button, reset or submit"
    },
    "kind": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'tertiary'",
          "computed": false
        }, {
          "value": "'borderless'",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicates button kind: primary, secondary, tertiary, borderless"
    },
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'large'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }]
      },
      "required": false,
      "description": "size of button"
    },
    "icon": {
      "defaultValue": {
        "value": "'none'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'none'",
          "computed": false
        }, {
          "value": "'only'",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `iconName`"
    },
    "includeRef": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "iconName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "icon name from Material Icons library"
    },
    "noPadding": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
export default Button;